export default __webpack_public_path__ + "static/media/promo-a.4da763db.png";